import type { SignalType } from 'types/signals'

export function paidSignalTypeForTarget(
    signalType: SignalType,
    ownsTarget: boolean,
    isSeed = false,
): SignalType {
    if (signalType === 'lock') return signalType

    return !isSeed && ownsTarget ? 'boost' : 'upvalue'
}

export function savedPaidSignalType(signalType: SignalType): SignalType {
    return signalType === 'boost' ? 'upvalue' : signalType
}
